module.exports = __webpack_public_path__ + "static/media/viv_2.1454d853.jpg";